/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
const e = "multiviewcalendar.prevView", t = "multiviewcalendar.nextView", a = "dateinput.increment", c = "dateinput.decrement", n = "dateinput.clear", i = "calendar.today", r = "datepicker.toggleCalendar", o = "daterangepicker.swapStartEnd", l = "daterangepicker.start", s = "daterangepicker.end", d = "daterangepicker.separator", g = "datetimepicker.toggleDateTimeSelector", p = "timepicker.now", m = "timepicker.selectNow", k = "timepicker.cancel", w = "timepicker.set", S = "timepicker.toggleTimeSelector", T = "timepicker.toggleClock", v = "datetimepicker.date", u = "datetimepicker.time", C = "datetimepicker.cancel", N = "datetimepicker.set", P = "daterangepicker.cancel", V = "daterangepicker.set", x = {
  [i]: "Today",
  [p]: "NOW",
  [w]: "Set",
  [k]: "Cancel",
  [v]: "Date",
  [u]: "Time",
  [C]: "Cancel",
  [N]: "Set",
  [P]: "Cancel",
  [V]: "Set",
  [l]: "Start",
  [s]: "End",
  [d]: " ",
  [m]: "Select Now",
  [S]: "Toggle TimeSelector",
  [T]: "Toggle Clock",
  [a]: "Increase value",
  [c]: "Decrease value",
  [n]: "clear",
  [r]: "Toggle calendar",
  [e]: "Navigate to previous view",
  [t]: "Navigate to next view",
  [o]: "Swap start and end values",
  [g]: "Toggle date-time selector"
};
export {
  n as clear,
  v as date,
  P as dateRangePickerCancel,
  V as dateRangePickerSet,
  C as dateTimePickerCancel,
  N as dateTimePickerSet,
  c as decreaseValue,
  s as end,
  a as increaseValue,
  x as messages,
  t as nextView,
  p as now,
  e as prevView,
  m as selectNow,
  d as separator,
  l as start,
  o as swapStartEnd,
  u as time,
  k as timePickerCancel,
  w as timePickerSet,
  i as today,
  r as toggleCalendar,
  T as toggleClock,
  g as toggleDateTimeSelector,
  S as toggleTimeSelector
};
